import { render, staticRenderFns } from "./AdminKeycloak.vue?vue&type=template&id=c03071ae&scoped=true"
import script from "./AdminKeycloak.vue?vue&type=script&lang=js"
export * from "./AdminKeycloak.vue?vue&type=script&lang=js"
import style0 from "./AdminKeycloak.vue?vue&type=style&index=0&id=c03071ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03071ae",
  null
  
)

export default component.exports